module.exports = __webpack_public_path__ + "fa58c202183a6578f7dd1850f8358293.fbx";